import React from 'react';
import styles from './Politics.module.css';

const Politics = ({ lang }) => {
  const data = {
    EN: {
      title: "Political Updates",
      btn: "Load More",
      news: [
        "New legislative reforms passed in Senate",
        "Diplomatic summit held in Geneva",
        "Local elections results announced",
        "Government announces new infrastructure plan",
        "International relations and trade policy",
        "Public policy debate in the capital"
      ]
    },
    UR: {
      title: "سیاسی خبریں",
      btn: "مزید دیکھیں",
      news: [
        "سینیٹ میں نئی قانون سازی کی اصلاحات",
        "جنیوا میں سفارتی سمٹ کا انعقاد",
        "مقامی انتخابات کے نتائج کا اعلان",
        "حکومت کا نئے انفراسٹرکچر پلان کا اعلان",
        "بین الاقوامی تعلقات اور تجارتی پالیسی",
        "دارالحکومت میں عوامی پالیسی پر بحث"
      ]
    }
  }[lang];

  return (
    <section className={styles.politicsSection}>
      <h2 className={styles.sectionHeader}>{data.title}</h2>
      
      <div className={styles.politicsContainer}>
        {data.news.map((item, i) => (
          <div key={i} className={styles.politicsCard}>
            <img src={`https://picsum.photos/400/250?random=${i + 7000}`} alt="politics" />
            <h4>{item}</h4>
          </div>
        ))}
      </div>

      <div className={styles.moreBtnWrapper}>
        <button className={styles.moreBtn}>{data.btn}</button>
      </div>
    </section>
  );
};

export default Politics;